import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Cabserviceinnavimumbai() {



const cardData = {
  keyword: " Cab Service in Navi Mumbai",

headingDescription:
  "Omshree Cab provides reliable and comfortable cab service in Navi Mumbai for travelers who need convenient and hassle‑free transportation within the city and nearby areas. Whether you’re heading to the airport, commuting for work, planning local sightseeing, attending events, or traveling to nearby destinations like Lonavala, Pune, or Alibaug, our cab service ensures a safe and smooth ride with experienced drivers and well‑maintained vehicles. We offer flexible booking options including one‑way rides, round trips, hourly rentals, and full‑day travel packages at transparent pricing. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, and tempo travelers, suitable for solo travelers, families, corporate groups, and tourists. With punctual pickups from any location in Navi Mumbai and 24/7 customer support, Omshree Cab is your trusted partner for dependable cab services in Navi Mumbai.",

topPlaces: [
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic fort in Navi Mumbai, offering visitors a glimpse into the region’s rich past. The fort provides scenic views of the surrounding area, making it a favorite spot for photography and local sightseeing. A cab service in Navi Mumbai makes it simple to reach Belapur Fort comfortably and enjoy its historic charm without transportation hassles."
  },
  {
    title: "Nerul Balaji Temple",
    description:
      "Nerul Balaji Temple, also known as the Shri Balaji Mandir, is a popular spiritual destination in Navi Mumbai. Devotees visit to participate in rituals, offer prayers, and enjoy the peaceful ambiance. Traveling by cab ensures a smooth and stress‑free visit to the temple from anywhere in Navi Mumbai."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a scenic natural attraction on the outskirts of Navi Mumbai, especially spectacular during the monsoon season. Visitors enjoy trekking, nature walks, photography, and picnics near the cascading waterfall. A cab ride makes it easy and convenient to reach the falls and spend ample time exploring the lush surroundings."
  },
  {
    title: "Central Park, Kharghar",
    description:
      "Central Park in Kharghar is one of Navi Mumbai’s largest parks, featuring beautiful gardens, walking paths, lakes, and recreational areas. Visitors come here for morning walks, cycling, family outings, and relaxation amidst greenery. Using a cab service is a comfortable way to reach Central Park, especially for groups and families looking to enjoy a day out."
  },
  {
    title: "Kharghar Hills Viewpoint",
    description:
      "Kharghar Hills Viewpoint offers panoramic views of Kharghar city, lakes, and surrounding hills. It’s a popular spot for nature lovers and photographers, especially during sunrise and sunset. A cab ride provides convenient access to this scenic viewpoint, making it easy to include in local sightseeing plans."
  },
  {
    title: "DY Patil Stadium",
    description:
      "DY Patil Stadium is a premier sports and entertainment venue in Navi Mumbai known for cricket matches, concerts, and major events. Visitors attend sporting events, live shows, and performances throughout the year. Booking a cab makes it simple to reach the stadium on time and return comfortably after events without parking challenges."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a popular landmark and public square in Kharghar, known for its French‑style architecture, fountains, and vibrant atmosphere. Visitors enjoy evening walks, photography, and meeting spots for friends and families. A cab service offers easy transportation to Utsav Chowk and nearby cafes and restaurants."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is a modern shopping and entertainment destination in Navi Mumbai, featuring retail stores, dining options, cinemas, and family‑friendly activities. Visitors can shop, dine, and enjoy leisure time in a vibrant indoor environment. A cab ride ensures convenient access, making it ideal for weekend plans and group outings."
  },
  {
    title: "Mango Garden",
    description:
      "Mango Garden in Nerul is a peaceful garden that offers green lawns, walking paths, and areas for picnics and relaxation. It’s a nice spot for families and friends to unwind amidst nature. Traveling by cab provides comfortable access to the garden and makes it easy to combine with other local attractions."
  },
  {
    title: "NMMC Garden",
    description:
      "NMMC Garden is a well‑maintained public garden offering walking trails, seating areas, and floral displays. Visitors enjoy nature walks, photography, and spending quality time with family. A cab service in Navi Mumbai ensures a comfortable and convenient way to reach this serene spot as part of a local sightseeing itinerary."
  }
],



services: [
{
name: "Cab Service in Navi Mumbai",
description: "Cab service in Navi Mumbai provides reliable and comfortable transportation for passengers traveling within the city and nearby destinations. Our fleet includes well-maintained AC sedans and SUVs suitable for local travel, airport transfers, and outstation trips. Professional drivers ensure punctual pickup and safe driving across all areas of Navi Mumbai including Vashi, Nerul, Belapur, and Kharghar. Pickup services are available from homes, offices, hotels, railway stations, and business hubs. Ideal for daily commuting, corporate travel, and family trips. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow easy ride scheduling anytime."
},
{
name: "Taxi Service in Navi Mumbai",
description: "Taxi service in Navi Mumbai offers convenient and dependable transportation for passengers looking for quick city travel. Our air-conditioned taxis ensure smooth journeys through city roads and highways connecting Navi Mumbai to Mumbai and Pune. Experienced drivers provide punctual pickup and professional service for every ride. Pickup services are available across residential areas, offices, hotels, malls, and railway stations in Navi Mumbai. Ideal for business travel, airport transfers, and daily commuting. Comfortable interiors ensure relaxed travel for passengers. Flexible booking options allow quick taxi reservations anytime."
},
{
name: "Navi Mumbai Cab Service",
description: "Navi Mumbai cab service provides comfortable and efficient transportation for passengers traveling across the city and surrounding regions. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for local and outstation travel. Professional drivers ensure safe driving and timely pickup services from all major locations in Navi Mumbai. Pickup services are available from homes, offices, hotels, airports, and railway stations. Ideal for corporate travel, tourism visits, and family journeys. Spacious interiors ensure comfortable seating during travel. Easy booking options make cab reservations quick and convenient."
},
{
name: "Navi Mumbai Taxi Service",
description: "Navi Mumbai taxi service offers reliable city transportation for passengers looking for convenient travel across the region. Our comfortable AC taxis ensure smooth journeys between residential areas, business districts, and transport hubs. Professional drivers provide punctual pickup and safe driving services. Pickup services are available across Navi Mumbai including Vashi, Panvel, Nerul, and CBD Belapur. Ideal for airport transfers, city tours, and business trips. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow easy ride scheduling at any time."
},
{
name: "Cab Booking Navi Mumbai",
description: "Cab booking in Navi Mumbai allows passengers to easily reserve comfortable vehicles for local and outstation travel. Our booking system provides quick confirmation and convenient ride scheduling for passengers. Professional drivers ensure punctual pickup and safe driving throughout the journey. Pickup services are available across residential areas, offices, hotels, railway stations, and airports in Navi Mumbai. Ideal for daily commuting, airport transfers, and family trips. Comfortable interiors ensure relaxed travel experiences. Flexible booking options make it simple to schedule rides anytime."
},
{
name: "Taxi Booking Navi Mumbai",
description: "Taxi booking in Navi Mumbai provides convenient transportation options for passengers looking to reserve taxis quickly. Our AC vehicles ensure smooth and comfortable travel across city roads and highways. Professional drivers ensure punctual pickup and safe driving services across Navi Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and personal trips. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow instant taxi reservations."
},
{
name: "Navi Mumbai Airport Cab Service",
description: "Navi Mumbai airport cab service provides reliable transportation for passengers traveling to or from nearby airport terminals. Comfortable AC vehicles ensure smooth journeys between Navi Mumbai and airport locations. Professional drivers monitor flight schedules to provide punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and business hubs across Navi Mumbai. Ideal for business travelers, tourists, and family trips. Spacious seating ensures comfortable airport journeys. Flexible booking options allow advance reservations for stress-free travel."
},
{
name: "Cheap Cab Service Navi Mumbai",
description: "Cheap cab service in Navi Mumbai offers affordable transportation for passengers looking for budget-friendly travel options. Our economical AC sedans provide comfortable rides for local and short-distance travel. Professional drivers ensure punctual pickup and safe driving services across Navi Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and commercial areas. Ideal for students, daily commuters, and budget travelers. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow convenient ride scheduling anytime."
},
{
name: "Best Taxi Service Navi Mumbai",
description: "Best taxi service in Navi Mumbai provides premium transportation experience with well-maintained vehicles and professional drivers. Our fleet includes comfortable AC sedans and SUVs suitable for local travel and long-distance journeys. Drivers ensure punctual pickup, safe driving, and courteous service throughout the trip. Pickup services are available across Navi Mumbai including residential areas, offices, hotels, and transport hubs. Ideal for corporate travel, airport transfers, and tourism visits. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow quick and easy taxi reservations."
}
],

tableData: [
["Cab Service in Navi Mumbai","Taxi Service in Navi Mumbai"],
["Navi Mumbai Cab Service","Navi Mumbai Taxi Service"],
["Cab Booking Navi Mumbai","Taxi Booking Navi Mumbai"],
["Navi Mumbai Airport Cab Service","Cheap Cab Service Navi Mumbai"],
["Best Taxi Service Navi Mumbai","Navi Mumbai Taxi Near Me"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Navi Mumbai Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Navi Mumbai’s major roads and highways including Vashi, Nerul, Belapur, Kharghar, Panvel, and nearby areas. They ensure safe and timely travel for passengers whether it is local rides, airport transfers, or outstation trips."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for cab services in Navi Mumbai. Customers are informed about per-kilometer fares, hourly packages, and travel costs before booking so there are no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "Our cab service in Navi Mumbai is available 24 hours a day. Whether you need an early morning airport drop or late-night travel, Omshree Cabs provides reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride for passengers."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Services",
    WhyChoosedescription: "Customers can book cabs for local travel within Navi Mumbai or for outstation journeys to destinations like Pune, Lonavala, Nashik, Surat, Shirdi, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers different vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for families, business travelers, and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports across Navi Mumbai including Vashi, Nerul, Belapur, Airoli, Ghansoli, and Panvel."
  },
  {
    WhyChooseheading: "Trusted Taxi Service in Navi Mumbai",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable taxi services in Navi Mumbai. Our punctual drivers, clean vehicles, and professional service ensure a smooth and stress-free journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab services in Navi Mumbai?", answer: "Yes, Omshree Cabs provides reliable cab services in Navi Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "Is cab service available 24 hours in Navi Mumbai?", answer: "Yes, our taxi service operates 24/7 for local rides, airport pickup and drop, and outstation travel." },
  { question: "Do you provide airport transfers from Navi Mumbai?", answer: "Yes, we provide airport pickup and drop services from Navi Mumbai to Mumbai Airport and Navi Mumbai International Airport." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on passenger requirements." },
  { question: "Do you provide outstation cab services from Navi Mumbai?", answer: "Yes, we provide outstation cab services from Navi Mumbai to Pune, Nashik, Lonavala, Shirdi, Surat, and many other destinations." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book a cab online?", answer: "Yes, customers can easily book a cab online or via phone for quick confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide corporate cab services in Navi Mumbai?", answer: "Yes, we provide corporate transportation services for business travel, employee transport, and airport transfers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Patil",
    feedback:
      "Very reliable cab service in Navi Mumbai. The driver arrived on time and the car was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Excellent taxi service from Navi Mumbai to Mumbai Airport. Smooth booking process and professional driver.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Navi Mumbai",
  "description": "Omshree Cab provides reliable cab service in Navi Mumbai for local travel, airport transfers, and outstation trips. Affordable fares, easy online booking, and trusted taxi service across Navi Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2700"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Cab Service in Navi Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab service in Navi Mumbai for local travel, airport transfers, and outstation trips. Affordable fares with easy online booking and trusted taxi service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinnavimumbai;